import React from 'react'
import { Divider, Link } from '@mui/material';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import HawksbillShow from './Component/HawksbillShow';

const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});

const CustomAccordion = styled(Accordion)`
  &.dark {
    color: white;
    background-color: #032546;
    
  }
`;

const AdoptaHawksbill = () => {

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='bg-white p-20'>
      <header>
        <h1 className='text-2xl font-bold text-[#F27920] pb-5'>Adopt a Hawksbill</h1>
        <Divider className='' />
      </header>




      <section>
        <p className='pt-5'>Hawksbill turtles are among the most endangered of all sea turtle species. With your help, we're
          making a difference!</p>
      </section>

      <div className='lg:flex gap-5 my-10'>
        <div className='lg:w-1/2 my-3 text-center'>

          <ThemeProvider theme={theme}>
            <Button color="secondary" variant="contained" >
              <Link href='/Support/AdoptaHawksbill30.html' target='_blank' rel='noopener noreferrer' style={{ color: '#ffffff' }}>

                <div className='text-center '>

                  <div className='text-2xl font-bold text-center py-2'><VolunteerActivismIcon fontSize='large' /> $30.00</div>
                  <div className='text-center'>Adopt A Hawksbill</div>
                </div>


              </Link>
            </Button>
          </ThemeProvider>


        </div>
        <div className='lg:w-1/2 my-3 text-center'>
          <ThemeProvider theme={theme}>
            <Button color="secondary" variant="contained" >
              <Link href='/Support/AdoptaHawksbill70.html' target='_blank' rel='noopener noreferrer' style={{ color: '#ffffff' }}>

                <div className='text-center'>

                  <div className='text-2xl font-bold text-center py-2'><VolunteerActivismIcon fontSize='large' /> $70.00</div>
                  <div className='text-center'>Adopt A Hawksbill</div>
                </div>


              </Link>
            </Button>
          </ThemeProvider>
        </div>
      </div>



      <div className='lg:flex gap-5 my-10'>
        <div className='lg:w-1/2 my-3 text-center'>

          <ThemeProvider theme={theme}>
            <Button color="secondary" variant="contained" >
              <Link href='/Support/AdoptaHawksbill30friend.html' target='_blank' rel='noopener noreferrer' style={{ color: '#ffffff' }}>

                <div className='text-center '>

                  <div className='text-2xl font-bold text-center py-2'><VolunteerActivismIcon fontSize='large' /> $30.00</div>
                  <div className='text-center'>Adopt A Hawksbill<br />for a friend</div>
                </div>


              </Link>
            </Button>
          </ThemeProvider>


        </div>
        <div className='lg:w-1/2 my-3 text-center'>
          <ThemeProvider theme={theme}>
            <Button color="secondary" variant="contained" >
              <Link href='/Support/AdoptaHawksbill70friend.html' target='_blank' rel='noopener noreferrer' style={{ color: '#ffffff' }}>

                <div className='text-center'>

                  <div className='text-2xl font-bold text-center py-2'><VolunteerActivismIcon fontSize='large' /> $70.00</div>
                  <div className='text-center'>Adopt A Hawksbill<br />for a friend</div>
                </div>


              </Link>
            </Button>
          </ThemeProvider>
        </div>
      </div>
      <section>



        <p className=''>The National Save The Sea Turtle Foundation is committed to the conservation of hawksbill
          turtles through the Florida Hawksbill Project and the newly founded St. Croix Hawksbill Project,
          which are both conducting groundbreaking research into the biology, ecology, and recovery of
          hawksbill turtles in these important foraging grounds.</p>

        <p className='pt-5'>In return for your contribution of $30, you will receive a digital Certificate of Adoption*, a
          photograph of one of the hawksbill turtles who became part of our research, and some of the
          interesting information we were able to glean from it.</p>

        <p className='pt-5'>For a more impactful contribution of $70, in addition you will receive a key ring with an authentic
          sea turtle flipper tag, Hawksbill Project stickers, and a small plush turtle.</p>


        <div className='mx-auto my-10'><HawksbillShow /></div>


        <p className='text-sm'>Remember - Adoptions are symbolic, and do not convey ownership or any form of permission to inappropriately
          interact with an Endangered Species. The National Save The Sea Turtle Foundation recognizes the importance of
          human adoption programs and does not intend to compete with or diminish their value in any way.</p>
      </section>





      <section className='my-10'>
        <CustomAccordion style={{ color: 'inherit' }}
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}

        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className='text-[#009293]' />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="dark"
          >
            <div><h2 className='text-xl'>Read More About the Florida and St. Croix Hawksbill Projects</h2></div>
          </AccordionSummary>
          <AccordionDetails>
            <p>The Florida Hawksbill Project began in 2004 after Dr. Larry Wood realized a surprisingly large
              number of hawksbill turtles were residing on the coral reefs offshore of Palm Beach Island,
              Florida, yet rarely do any ever use Florida's beaches for nesting. This seeming contradiction led
              to the systematic census of the hawksbill turtles that were residing not only there, but
              throughout Florida's extensive coral reef ecosystem, which leads all the way to Key West.</p>

            <p className='pt-5'>More recently, our research team has begun a new project in St. Croix, U.S. Virgin Islands that
              intends to do much the same. Not only has the foraging population around the majority of the
              Island never been studied, but it also includes adult males and females that reproduce there on
              a regular basis. The interconnections between the resident juveniles and reproductive adults will
              be a major focus of the new study.</p>


            <p className='pt-5'>For more details, see <Link href='https://savetheseaturtle.org/HawksbillProject/' title='The Florida Hawksbill Project' color='inherit'>https://savetheseaturtle.org/HawksbillProject/</Link></p>

          </AccordionDetails>
        </CustomAccordion>

        <p className='pt-5'>&quot;All research activities conducted with the permission of State and Federal agencies&quot;</p>

      </section>
    </div >
  )
}

export default AdoptaHawksbill